import { DOM_CLASS_NAMES, DOM_IDS, PAGE_TYPE } from 'CmsManagePreferences/utils/constants';
import { getLanguageCodeFromUrl, getRedirectUrl, redirectToUrl } from 'CmsManagePreferences/js/utils/url';

// TODO: Handle Failure Scenario
export const getUrlForLanguage = (url, newCode) => {
  const urlObj = new URL(url);
  const pathParams = urlObj.pathname.split('/');
  pathParams[pathParams.length - 2] = newCode === 'default' ? 'en' : newCode;
  urlObj.pathname = pathParams.join('/');
  const newUrl = urlObj.toString();
  return newUrl;
};
const setElementAttributeById = (id, attribute, value) => {
  const element = document.getElementById(id);
  if (element) {
    // @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    element[attribute] = value;
  }
};
export const setCheckboxById = (id, value) => {
  setElementAttributeById(id, 'checked', value);
};
export const setInnerTextById = (id, value) => {
  setElementAttributeById(id, 'innerText', value);
};
export const setDisabledById = (id, value) => {
  setElementAttributeById(id, 'disabled', value);
};
export const setDisplayById = (id, value) => {
  const element = document.getElementById(id);
  if (element) {
    element.style.display = value;
  }
};
export const setInputTextByQuerySelector = (locator, value) => {
  const element = document.querySelector(locator);
  if (element) {
    element.value = value;
  }
};
export const createElementFromHTML = htmlString => {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
};
export const createSpanElement = innerText => innerText ? `<span>${innerText}</span>` : '';
export const getTranslatedDefinition = subscriptionStatus => {
  const langSelected = getSelectedLanguage();
  const langToUse = subscriptionStatus.translations.hasOwnProperty(langSelected) ? langSelected : subscriptionStatus.primaryLanguage;
  const subscriptionDefinition = langToUse ? subscriptionStatus.translations[langToUse] : subscriptionStatus.translations[0]; // Fallback to first languag
  return subscriptionDefinition;
};
export const getSubscriptionDefitionNode = ({
  id,
  subscribed,
  category,
  channel,
  name,
  description
}, sentSubscriptionId) => {
  const hasSeparatorSpan = category || channel;
  const innerClass = ['item-inner'];
  sentSubscriptionId === id && innerClass.push('highlighted-subscription');
  subscribed && innerClass.push('selected');

  // This structure needs to be in sync with the Jinja files
  const subscriptionDefinitionNode = `
  <div class="${innerClass.join(' ')}">
    <div class="checkbox-row">
      <span class="fakelabel">
        <input id="id_${id}" type="checkbox" ${subscribed && 'checked'} name="id_${id}">
        ${createSpanElement(category)}
        ${createSpanElement(channel)}
        ${hasSeparatorSpan ? createSpanElement(' | ') : ''}
        ${createSpanElement(name)}
      </span>
    </div>
  <p>${description}</p>
  </div>`;
  return subscriptionDefinitionNode;
};
export const getSelectedLanguage = () => {
  const langSelect = document.getElementById(DOM_IDS.languageSelect);
  return langSelect ? langSelect.value : '';
};
export const setSubscriptionIdsNode = subIdString => {
  const subIdsNodes = document.getElementsByName(DOM_CLASS_NAMES.subIds);
  if (subIdsNodes && subIdsNodes.length > 0) {
    const subIdsInputNode = subIdsNodes[0];
    if (subIdsInputNode.value) {
      subIdsInputNode.value = `${subIdsInputNode.value},${subIdString}`;
    } else {
      subIdsInputNode.value = `${subIdString}`;
    }
  }
};

/**
 * Sanitizes user input text for safe display by HTML-encoding special characters.
 *
 * This function protects against XSS attacks by escaping HTML entities.
 * Used for user-provided text that will be submitted to backend services.
 *
 * @param text - The input text to sanitize
 * @returns Sanitized text with HTML entities escaped, or null if input is empty
 */

export const sanitizeText = text => {
  if (!text || !text.trim()) return null;
  return text.trim() // Remove leading/trailing whitespace
  .replace(/&/g, '&amp;') // Escape ampersand first
  .replace(/</g, '&lt;') // Escape HTML less-than
  .replace(/>/g, '&gt;') // Escape HTML greater-than
  .replace(/"/g, '&quot;') // Escape double quotes
  .replace(/'/g, '&#x27;') // Escape single quotes
  .replace(/\n/g, ' ') // Replace newlines with spaces
  .replace(/\s+/g, ' '); // Collapse multiple spaces
};
export const getSubscriptionNameFromDefinition = sentDefinition => {
  var _sentDefinition$selec, _sentDefinition$first;
  if (!sentDefinition) {
    return '';
  }
  const selectedLanguage = getLanguageCodeFromUrl();
  if (selectedLanguage && (_sentDefinition$selec = sentDefinition[selectedLanguage]) !== null && _sentDefinition$selec !== void 0 && _sentDefinition$selec.name) {
    return sentDefinition[selectedLanguage].name;
  }
  const firstAvailableLanguage = Object.keys(sentDefinition)[0];
  if (firstAvailableLanguage && (_sentDefinition$first = sentDefinition[firstAvailableLanguage]) !== null && _sentDefinition$first !== void 0 && _sentDefinition$first.name) {
    return sentDefinition[firstAvailableLanguage].name;
  }
  return '';
};
export function redirectToFallbackPage() {
  const fallbackUrl = getRedirectUrl(PAGE_TYPE.failure);
  redirectToUrl(fallbackUrl);
}
export function redirectToPreferencesPage() {
  const preferencesUrl = getRedirectUrl(PAGE_TYPE.preferences);
  redirectToUrl(preferencesUrl);
}
export const setSubscriptionNameInUI = subscriptionName => {
  const element = document.getElementById(DOM_IDS.singleUnsubSubscriptionName) || document.getElementById('subscription-name');
  if (element) {
    element.textContent = subscriptionName;
  }
};